import * as React from 'react'
import { FunctionComponent } from 'react'
import { useFormikContext } from 'formik'
import PhoneNumberField from '../Form/PhoneNumberField'
import { IFormattableTextFieldProps } from '../Form/FormattableTextField'

type Props = {
    label: string
    fieldName: string
    textFieldProps?: Omit<IFormattableTextFieldProps, 'label'>
}

const FormikPhoneNumberField: FunctionComponent<Props> = props => {
    const { values, errors, handleChange } = useFormikContext()

    return (
        <PhoneNumberField
            label={props.label}
            value={values[props.fieldName]}
            errorMessage={errors?.[props.fieldName]}
            onChange={handleChange(props.fieldName)}
            {...(props.textFieldProps || {})}
        />
    )
}

export default FormikPhoneNumberField
